<template>
  <div class="container">
      <div class="row">
          <!-- Header -->
          <div class="col-12 box-header">
            <span class="name-page">แก้ไขที่อยู่จัดส่ง</span>
          </div>
          <!-- Header -->
      </div>
      <Address/>
  </div>
</template>

<script>
import Address from "@/components/Modal/Address/Add/AddAddressModal.vue";
export default {
    name: "History-Point",   
    components: {
        Address
    },
    data: function() {
        return {
        };
    },
    created: function() {
    },
    methods: {
    },
}

</script>

<style lang="scss" scoped>
@import "@/style/termscondition.scss";
</style>